export const footer = {
  footerLinks: [
    {
      text: "TÉRMINOS DE USO",
      href: "/terms-of-use",
    },
    {
      text: "PRIVACIDAD",
      href: "/privacy-policy",
    },
    {
      text: "AKROS ANTI-CHEAT",
      href: "/anti-cheat",
    },
    {
      text: "SOBRE NOSOTROS",
      href: "/about-us",
    },
    {
      text: "ACTUALIZACIONES",
      href: "/changelog",
    },
  ],
  socialMediaLinks: [
    {
      social: "email",
      href: "mailto:contacto@esgplay.com",
    },
    {
      social: "facebook",
      href: "https://www.facebook.com/esgplaylatam",
    },
    {
      social: "youtube",
      href: "https://www.youtube.com/channel/UC6rq7s0ZpaitYCLmP9kCUUA",
    },
    {
      social: "instagram",
      href: "https://www.instagram.com/esgplay",
    },
    {
      social: "twitter",
      href: "https://twitter.com/esgplay",
    },
    {
      social: "discord",
      href: "https://discord.com/invite/dwZhuv6",
    },
  ],
};
